package br.com.vvrefeicoes.portal.domain.model

data class Session(
    val token: String,
    val userName: String,
    val fullName: String = "",
    val role: UserRole? = null,
    val companies: List<CompanyRef> = emptyList(),
    val permissions: Map<String, Set<PermissionAction>> = emptyMap(),
) {
    val displayName: String
        get() = fullName.ifBlank { userName }
}
